import { render, staticRenderFns } from "./customer-feedback.vue?vue&type=template&id=65a1615c&scoped=true&"
import script from "./customer-feedback.vue?vue&type=script&lang=js&"
export * from "./customer-feedback.vue?vue&type=script&lang=js&"
import style0 from "./customer-feedback.vue?vue&type=style&index=0&id=65a1615c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1615c",
  null
  
)

export default component.exports